import "../roleManage/ant_table.scss";
export default {
    data() {
        return {
            // 分页信息
            pageOption:{
                pageSize: 10,
                // 默认页
                current: 1,
                // 总数
                total: 0,
                showSizeChanger: true, // 是否可以改变 pageSize
                pageSizeOptions: ['5', '10', '20', '30', '40', '50'], // 可选的每页显示数据数量
                // 翻页
                onChange:this.onChangPage,
                showTotal: (total) => `共计 ${total.toLocaleString()} 条记录`,
                // 显示数
                onShowSizeChange: this.onShowSizeChange,
                //分页样式配置
                itemRender:this.itemRender
            },
        }
    },
    methods: {
        // 切换页
        onChangPage(page, pageSize) {
            // this.pageOption.pageSize = pageSize
            this.pageOption.current = page
            this.startRequest()
        },
        // 切换显示条数
        onShowSizeChange(current, size) {
            this.pageOption.pageSize = size
            // pageParams.pageNum = 1
            this.pageOption.current = 1
            this.startRequest()
        },
        itemRender(current, type, originalElement) {
            if (type === 'prev') {
                return <a class="pagePN"><span class="triangleLeft"></span>上一页</a>;
            }
            if (type === 'next') {
                return <a class="pagePN">下一页<span class="triangleRight"></span></a>;
            }
            return originalElement;
        },
    },
    computed:{
    }
}